import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Grid2 as Grid, Slider, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import { ColorPicker } from "../../../chart/colorPicker";
import { GRAPH_TYPE } from "../../../../constants/trendGraph/trendGraphType";
import { useSelector } from "react-redux";
import { isChartsFetching } from "../../../../model/slice/chartsSlice";
import { getDashboardLiveTrendData } from "../../../../model/slice/customDashboardSlice";

export const LiveComponentSettings = (props) => {
  const { vessel, item, chartRef, thickness, setThickness } = props;
  const theme = useTheme();
  const isChartsFetch = useSelector(isChartsFetching);
  const initialData = useSelector(getDashboardLiveTrendData);
  const [displayColorPickerFlag, setDisplayColorPickerFlag] = useState(false);
  const [displayColorPicker, setDisplayColorPicker] = useState({
    flag: "",
    position: 0,
    isDigital: false,
  });
  const [dataKeyName, setDataKeyName] = useState("");
  const [displayDataKeyName, setDisplayDataKeyName] = useState('');
  const [linesData, setLinesData] = useState({});

  useEffect(() => {
    if (!chartRef?.current?.series) return;

    const tmp = {};
    chartRef.current.series.each((series) => {
      tmp[series.get("name").toString()] = {
        color: series.get("stroke").toString(),
        name: series.get("name").toString(),
      };
    });

    setLinesData(tmp);
  }, [chartRef?.current]);

  useEffect(() => {
    if (!chartRef?.current) return;
    //for User change line color trick
    if (displayColorPicker.flag == "" || displayColorPicker.position == 0) {
      // Do nothing
    } else {
      // if(displayColorPicker.isDigital) {
      //   refDigitalChart.current.series.each(function (item, index) {
      //     if (displayColorPicker.flag == item.get('key')) {
      //       //color change trick
      //       item.set("fill", am5.color(displayColorPicker.position));
      //       item.set("stroke", am5.color(displayColorPicker.position));

      //       // necessary for column series to set color using both item.set() and item.columns.template.setAll()
      //       if (item instanceof am5xy.ColumnSeries) {
      //         item.columns.template.setAll({
      //           fill: am5.color(displayColorPicker.position),
      //           stroke: am5.color(displayColorPicker.position),
      //         });
      //       }
      //     }
      //     digitalLegendRef.current.data.setAll(refDigitalChart.current.series.values);
      //     addLegendFeatures(digitalRootRef.current, refDigitalChart.current, digitalLegendRef.current);
      //   })
      // }else{
        chartRef.current.series.each(function (it, index) {
          if (displayColorPicker.flag == it.get('name')) {
            it.setAll({
              fill: am5.color(displayColorPicker.position),
            })

            it.bulletsContainer.children.each((bullet) => {
              bullet.set("fill", am5.color(displayColorPicker.position));
            });

            linesData[it.get('name')].color = displayColorPicker.position;
          }
        });
      }
      chartRef.current.series.each(function (series, i) {
        if (series instanceof am5xy.LineSeries && series.get("isDigitalChannel")) {
          if (series.get("legendDataItem")) series.get("legendDataItem").dispose();
        }
      });
    // }
  }, [displayColorPicker]);

  useEffect(() => {
    if (!chartRef?.current) return;
 
    chartRef.current.series.each(function (it) {
        it.setAll({
          strokeWidth: thickness,
        });

        it.bulletsContainer.children.each((bullet) => {
          bullet.set("radius", thickness);
        });
    });
  }, [thickness]);

  return isChartsFetch ? <CircularProgress /> : (
    <Box>
      <Box sx={{
        width: '100%',
        marginBottom: '24px',
      }}>
        <Box component={"div"} sx={{
          color: 'white',
          marginBottom: '8px',
        }}>
          Line Thickness
        </Box>
        <Box sx={{
          width: '80%',
          maxWidth: '300px',
          display: 'flex',
          gap: '12px',
          padding: '0 12px'
        }}>
          <Box component="div" sx={{
            width: "30px",
            height: "25px",
            background: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <span>{thickness}</span>
          </Box>
          <Slider
            aria-label="Line Thickness"
            defaultValue={item.thickness ?? 2}
            onChangeCommitted={(event, value) => setThickness(value)}
            valueLabelDisplay="auto"
            shiftStep={2}
            step={0.5}
            marks
            min={1}
            max={5}
            track={false}
          />
        </Box>
      </Box>
      <Grid container size={12} height={"100%"} direction={"row"} sx={{
            fontSize: "14px",
            color: "white",
            marginTop: "16px",
            columnCount: "2",
            columnFill: "auto",
            gap: "8px",
          }}>
        {item.chNos.map((chNo, i) => {
          const channelNumberIndex = initialData[item.id]?.config?.chNo?.findIndex((v) => v === chNo);
          const channelName = initialData[item.id]?.config?.chName?.[channelNumberIndex];
          return (
            <Box component="div" key={i} sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
              }}
              onClick={() => { 
                setDisplayDataKeyName(channelName);
                setDataKeyName(chNo);
                setDisplayColorPickerFlag(true);
              }}
              >
              <Box component="div">
                <Box component="div" sx={{
                    width: "10px",
                    height: "2px",
                    flexGrow: 0,
                    borderRadius: "1px",
                    backgroundColor: linesData[chNo]?.color,
                  }} 
                />
              </Box>
              <Box component="div" sx={{
                minWidth: '110px',
                maxWidth: '110px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                [theme.breakpoints.down('lg')]: {
                  minWidth: '100px',
                  maxWidth: '100px',
                }
              }}>{channelName ?? ""}</Box>
            </Box>
          );
        })}
      </Grid>
      <Box
        className="colorPickerContainer"
        sx={{
          width: "fit-content",
          visibility: displayColorPickerFlag ? "visible" : "hidden",
          position: "absolute",
          left: 0,
          top: 0,
        }}
      >
        <Box sx={{ left: `10px` }}>
          <ColorPicker
            setDisplayColorPicker={setDisplayColorPicker}
            graphType={GRAPH_TYPE.LIVE}
            dataKey={dataKeyName}
            displayDataKeyName={displayDataKeyName}
            isDigital={false}
            setOnClose={setDisplayColorPickerFlag}
            chartType={item.id}
            isComparison={false}
            vesselId={vessel.id}
          />
        </Box>
      </Box>
    </Box>
  );
};

LiveComponentSettings.propTypes = {
  vessel: PropTypes.object,
  item: PropTypes.object,
  chartRef: PropTypes.object,
  thickness: PropTypes.number,
  setThickness: PropTypes.func,
};

export default LiveComponentSettings;